import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import ROLES, { CONTACT_EMAIL } from '../lib/roles';
import '../styles/home.css';
import '../styles/careers.css';

/*
 * Careers index.
 *
 * Reachable at /careers and linked only from the footer. Deliberately out of
 * the top nav: the header's job is to move an operator toward an assessment,
 * and a hiring link there competes with it.
 */
function Careers() {
  return (
    <>
      <Nav />
      <main className="careers">
        <div className="wrap careers-head">
          <p className="eyebrow">Careers</p>
          <h1 className="h1 careers-head-title">Come make it quiet.</h1>
          <p className="lead careers-head-lead">
            We are a small venture-backed team in Brooklyn designing, printing,
            and testing acoustic materials that make data centers quiet. Work
            here lands on a customer site, not in a drawer.
          </p>
        </div>

        <div className="wrap careers-list">
          <p className="eyebrow careers-list-head">Open roles</p>

          {ROLES.length === 0 ? (
            <p className="careers-empty">
              Nothing open right now. If you think you should be working here
              anyway, tell us why at{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="careers-empty-link">
                {CONTACT_EMAIL}
              </a>
              .
            </p>
          ) : (
            ROLES.map((role) => (
              <article className="careers-item" key={role.slug}>
                <Link to={`/careers/${role.slug}`} className="careers-item-link">
                  <div className="careers-item-meta">
                    <span>{role.kind}</span>
                    <span aria-hidden="true">&middot;</span>
                    <span>{role.location}</span>
                  </div>
                  <h2 className="careers-item-title">{role.title}</h2>
                  <p className="careers-item-teaser">{role.teaser}</p>
                  <span className="link-arrow careers-item-more">
                    Read the role <span aria-hidden="true">&rarr;</span>
                  </span>
                </Link>
              </article>
            ))
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Careers;
